import { CancelIcon, CheckThinIcon, DeleteIcon, EditIcon } from '@redis-ui/icons';
import { LoaderLargeIcon } from '@redis-ui/icons/multicolor';
import * as S from './TableRowButtons.style';
import { TableRowButtonsProps } from './TableRowButtons.types';

const TableRowButtons = (props: TableRowButtonsProps) => {
  const {
    handleEditButtonClick,
    handleSubmitButtonClick,
    handleCancelButtonClick,
    handleDeleteButtonClick,
    isSubmitOrEditHidden,
    isCancelOrDeleteHidden,
    isSubmitOrEditDisabled,
    isCancelOrDeleteDisabled,
    editMode,
    isSubmitting,
    className
  } = props;

  const getSubmitIcon = () => {
    if (isSubmitting) {
      return LoaderLargeIcon;
    }

    if (editMode) {
      return CheckThinIcon;
    }

    return EditIcon;
  };

  return (
    <S.TableRowButtonsContainer editMode={editMode} className={className}>
      {!isSubmitOrEditHidden && (
        <S.ActionSubmitButton
          icon={getSubmitIcon()}
          size="L"
          onClick={editMode ? handleSubmitButtonClick : handleEditButtonClick}
          data-testid={`button--${editMode ? 'submit' : 'edit'}-entry`}
          disabled={isSubmitOrEditDisabled}
        />
      )}
      {!isCancelOrDeleteHidden && (
        <S.ActionCancelButton
          icon={editMode ? CancelIcon : DeleteIcon}
          size="L"
          variant="secondary"
          disabled={isCancelOrDeleteDisabled}
          data-testid={`button--${editMode ? 'dismiss' : 'remove'}-entry`}
          onClick={editMode ? handleCancelButtonClick : handleDeleteButtonClick}
        />
      )}
    </S.TableRowButtonsContainer>
  );
};

export default TableRowButtons;
